<template>
  <div class="accountManage-bd">
    <div class="comp-bg">
      <t-header></t-header>
      <div class="comp-head ub ub-sp ub-xc">
        <div class="ub ub-xc">
          <div>
            <img v-if="partnerLogo" style="border-radius: 16px;width: auto;height: 80px;" :src="partnerLogo" alt="" />
            <img v-else style="border-radius: 16px;width: auto;height: 80px;" src="../../images/logo.png" alt="" />
          </div>
          <div class="info">
            <h1>{{ userInfo.rootOrgName }}</h1>
          </div>
        </div>
        <div>
          <div class="btn" @click="jump('/account/manage/safe')">
            <img src="../../images/safe.png" alt="" />
            <span>{{ $t('accountManage.zhang_hao_an_quan') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="comp-wrapper ub">
      <div class="comp-left ub-f1">
        <div class="base">
          <div class="title ub ub-sp">
            <h1>{{ $t('accountManage.lian_xi_xin_xi') }}</h1>
            <div class="btn" @click="editInfo">
              <i class="icon icon-bianji"></i>
            </div>
          </div>
          <div class="sub-title">{{ $t('accountManage.qtxndlxxxyCEnksdlxdn') }}</div>
          <div class="box">
            <ul>
              <li>
                <span>{{ $t('accountManage.gong_si_ming_cheng') }}</span>
                {{ userInfo.rootOrgName }}
              </li>
              <li>
                <span>{{ $t('accountManage.yuan_gong_xing_ming') }}</span>
                {{ userInfo.realName }}
              </li>
              <li>
                <span>{{ $t('accountManage.lian_xi_dian_hua') }}</span>
                {{ userInfo.mobile }}
              </li>
              <!-- <li>
                <span>Email:</span>
                {{ userInfo.email }}
              </li> -->
            </ul>
          </div>
        </div>
        <div class="address" v-if="funcView.address_list">
          <div class="title ub ub-sp ub-xc">
            <h1>{{ $t('accountManage.shou_huo_di_zhi') }}</h1>
            <div class="btn" @click="addAddress" v-if="funcView.address_add">
              <i class="icon icon-tianjia"></i>
            </div>
          </div>
          <div class="box grey" v-for="item in addressList" :key="item.deliverAddressId">
            <ul>
              <li>
                <span>{{ $t('accountManage.shou_huo_di_zhi') }}</span>
                {{ item.country }} {{ item.province }} {{ item.city }} {{ item.detailAddress }}
              </li>
              <li>
                <span>{{ $t('accountManage.shrxm') }}</span>
                {{ item.consigneeName }}
              </li>
              <li>
                <span>{{ $t('accountManage.shrdh') }}</span>
                {{ item.consigneePhone }}
              </li>
            </ul>
            <h2 class="ub ub-sp">
              <span></span>
              <div>
                <el-switch
                  size="mini"
                  v-model="item.isDefault"
                  :disabled="item.isDefault"
                  :active-text="$t('accountManage.mo_ren')"
                  style="transform: scale(0.9)"
                  @change="defaultAddress(item)"
                  v-if="funcView.address_default"
                ></el-switch>
                &ensp;
                <el-button size="mini" type="text" style="color: #eb5a5a" @click="deleteAddress(item)" v-if="funcView.address_del">
                  <i class="icon icon-shanchu1" style="color: #eb5a5a"></i>
                  {{ $t('Common.com_delete') }}
                </el-button>
                &ensp;
                <el-button size="mini" type="text" style="color: #1a1a1a" @click="editAddress(item)" v-if="funcView.address_edit">
                  <i class="icon icon-bianji" style="color: #1a1a1a"></i>
                  {{ $t('Common.com_edit') }}
                </el-button>
              </div>
            </h2>
          </div>
        </div>
        <div class="invoice" v-if="funcView.invoice_list">
          <div class="title ub ub-sp ub-xc">
            <h1>{{ $t('accountManage.fa_piao_tai_tou') }}</h1>
            <div class="btn" @click="onAddBody" v-if="funcView.invoice_add">
              <i class="icon icon-tianjia"></i>
            </div>
          </div>
          <div class="box grey" v-for="item in invoiceList" :key="item.partnerInvoiceId">
            <ul>
              <li>
                <span>{{ $t('accountManage.ming_cheng') }}</span>
                {{ item.buyerName }}
              </li>
              <li>
                <span>{{ $t('accountManage.shui_hao') }}</span>
                {{ item.buyerNumber }}
              </li>
              <li>
                <span>{{ $t('accountManage.dan_wei_di_zhi') }}</span>
                {{ item.buyerRegisterAddress }}
              </li>
              <li>
                <span>{{ $t('accountManage.dian_hua_hao_ma') }}</span>
                {{ item.buyerMobile }}
              </li>
              <li>
                <span>{{ $t('accountManage.kai_hu_yin_hang') }}:</span>
                {{ item.buyerDepositBank }}
              </li>
              <li>
                <span>{{ $t('accountManage.yin_hang_zhang_hao') }}</span>
                {{ item.buyerDepositNumber }}
              </li>
              <li>
                <span>{{ $t('Common.com_email') }}:</span>
                {{ item.buyerEmail }}
              </li>
            </ul>
            <h2 class="ub ub-sp">
              <span></span>
              <div>
                <el-switch
                  size="mini"
                  v-model="item.isDefault"
                  :active-text="$t('accountManage.mo_ren')"
                  :disabled="!!item.isDefault"
                  :active-value="1"
                  :inactive-value="0"
                  @change="onDefault(item.partnerInvoiceId)"
                  style="transform: scale(0.9)"
                  v-if="funcView.invoice_default"
                ></el-switch>
                &ensp;
                <el-button size="mini" type="text" style="color: #eb5a5a" @click="onDeleteBody(item.partnerInvoiceId)" v-if="funcView.invoice_del">
                  <i class="icon icon-shanchu1" style="color: #eb5a5a"></i>
                  {{ $t('Common.com_delete') }}
                </el-button>
                &ensp;
                <el-button size="mini" type="text" style="color: #1a1a1a" @click="onEditBody(item)" v-if="funcView.invoice_edit">
                  <i class="icon icon-bianji" style="color: #1a1a1a"></i>
                  {{ $t('Common.com_edit') }}
                </el-button>
              </div>
            </h2>
          </div>
        </div>
      </div>
      <div class="comp-right">
        <div class="msg-set">
          <div class="title">
            <h1>{{ $t('accountManage.xiao_xi_she_zhi') }}</h1>
          </div>
          <div class="box">
            <ul>
              <h2>{{ $t('accountManage.zhan_nei') }}</h2>
              <div class="ub">
                <li v-for="(item, index) in dic.bas_msg_class" :key="`site-${index}`">
                  <el-switch
                    v-if="site[item.value] != undefined"
                    size="mini"
                    v-model="site[item.value]"
                    :inactive-text="item.name"
                    style="transform: scale(0.9)"
                    @change="switchMsg('site', item.value, site[item.value])"
                  ></el-switch>
                </li>
              </div>
              <h2>{{ $t('Common.com_email') }}</h2>
              <div class="ub">
                <li v-for="(item, index) in dic.bas_msg_class" :key="`email-${index}`">
                  <el-switch
                    v-if="email[item.value] != undefined"
                    size="mini"
                    v-model="email[item.value]"
                    :inactive-text="item.name"
                    style="transform: scale(0.9)"
                    @change="switchMsg('email', item.value, email[item.value])"
                  ></el-switch>
                </li>
              </div>
              <h2>{{ $t('accountManage.duan_xin') }}</h2>
              <div class="ub">
                <li v-for="(item, index) in dic.bas_msg_class" :key="`sms-${index}`">
                  <el-switch
                    v-if="sms[item.value] != undefined"
                    size="mini"
                    v-model="sms[item.value]"
                    @change="switchMsg('sms', item.value, sms[item.value])"
                    :inactive-text="item.name"
                    style="transform: scale(0.9)"
                  ></el-switch>
                </li>
              </div>
            </ul>
          </div>
        </div>
        <div class="bank-set" v-if="funcView.bank_list">
          <div class="title ub ub-sp">
            <h1>{{ $t('accountManage.yin_hang_ka') }}</h1>
            <div class="btn" @click="onAddBtn" v-if="funcView.bank_add">
              <i class="icon icon-tianjia"></i>
            </div>
          </div>
          <div class="box" v-for="item in bankcardList" :key="item.bankcardId">
            <div class="ub ub-sp">
              <div></div>
              <div>
                <el-switch
                  size="mini"
                  v-model="item.isDefault"
                  :active-text="$t('accountManage.mo_ren')"
                  :disabled="!!item.isDefault"
                  :active-value="true"
                  :inactive-value="false"
                  @change="onDefaultBtn(item.bankcardId)"
                  style="transform: scale(0.9)"
                  v-if="funcView.bank_default"
                ></el-switch>
                &ensp;
                <el-button size="mini" type="text" style="color: #eb5a5a" @click="onDeleteBtn(item.bankcardId)" v-if="funcView.bank_del">
                  <i class="icon icon-shanchu1" style="color: #eb5a5a"></i>
                  {{ $t('Common.com_delete') }}
                </el-button>
                &ensp;
                <el-button size="mini" type="text" style="color: #ffffff" @click="onEditBtn(item)" v-if="funcView.bank_edit">
                  <i class="icon icon-bianji" style="color: #ffffff"></i>
                  {{ $t('Common.com_edit') }}
                </el-button>
              </div>
            </div>
            <div class="num">
              {{ item.depositNumber }}
            </div>
            <div class="ub">
              <div class="label" style="font-weight: normal">{{ $t('accountManage.zhang_hu_lei_xing') }}</div>
              <div class="ub-f1 info" style="font-weight: normal">{{ $t('accountManage.kai_hu_yin_hang') }}</div>
            </div>
            <div class="ub info">
              <div class="label">{{ getDicValue('bank_deposit_type', item.depositType) }}</div>
              <div class="ub-f1 info">{{ item.depositBank }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <address-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getAddressList"></address-dialog>
    <invoice-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false" @success="getInvoiceList"></invoice-dialog>
    <bank-card-dialog v-if="dialogVisible2" :model="dialogModel2" @close="dialogVisible2 = false" @success="getBankcardList"></bank-card-dialog>
    <info-dialog v-if="dialogVisible3" :model="dialogModel3" @close="dialogVisible3 = false"></info-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import tHeader from '@/components/header.vue';
import infoDialog from './children/info_dialog.vue';
import addressDialog from './children/address_dialog.vue';
import invoiceDialog from './children/invoice_dialog.vue';
import bankCardDialog from './children/bank_cards_dialog.vue';

export default {
  name: 'accountManage',
  components: { tHeader, infoDialog, addressDialog, invoiceDialog, bankCardDialog },
  data() {
    return {
      value1: '',
      addressList: [],
      invoiceList: [],
      bankcardList: [],
      site: {},
      email: {},
      sms: {},

      dialogVisible: false,
      dialogModel: {},
      dialogVisible1: false,
      dialogModel1: {},
      dialogVisible2: false,
      dialogModel2: {},
      dialogVisible3: false,
      dialogModel3: {},
      partnerLogo: null
    };
  },
  created: function () {
    this.getDictionary('bas_msg_class');
  },
  mounted: function () {
    this.getMsgList();
    this.getLogo();
    this.getFuncView(null, () => {
      if (this.funcView.address_list) {
        this.getAddressList();
      }
      if (this.funcView.invoice_list) {
        this.getInvoiceList();
      }
      if (this.funcView.bank_list) {
        this.getBankcardList();
      }
    });
  },
  methods: {
    editInfo() {
      this.dialogModel3 = {
        title: this.$t('accountManage.bjlxxx'),
        userInfo: this.userInfo,
      };
      this.dialogVisible3 = true;
    },
    // 地址列表
    getAddressList() {
      this.$getJSON(apis.partnerDeliverAddress).then((res) => {
        this.addressList = res.data;
      });
    },
    // 获取图片列表
    getLogo() {
      this.$getFileList({ bizId: this.userInfo.rootOrgId, bizType: 'crm.partner.logo' }).then((list) => {
        this.partnerLogo = list.length > 0 ? list[0].attachPath : null;
      });
    },
    // 新增地址
    addAddress() {
      this.dialogModel = {
        type: 'add',
        title: this.$t('accountManage.xzshdz'),
      };
      this.dialogVisible = true;
    },
    // 编辑地址
    editAddress(item) {
      this.dialogModel = {
        type: 'edit',
        title: this.$t('accountManage.bjshdz'),
        data: { item, id: item.deliverAddressId },
      };
      this.dialogVisible = true;
    },
    // 删除地址
    deleteAddress: function ({ deliverAddressId }) {
      this.$showConfirm(this, this.$t('accountManage.nqdyscxzdshdzm'))
        .then(() => {
          this.$deleteJSON(`${apis.partnerDeliverAddressDelete}/${deliverAddressId}`).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getAddressList();
          });
        })
        .catch(() => {});
    },
    // 设为默认
    defaultAddress: function ({ deliverAddressId }) {
      this.$postJSON(`${apis.partnerDeliverAddressDefualt}/${deliverAddressId}`).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.getAddressList();
      });
    },
    // --------------发票主体
    onAddBody: function () {
      this.dialogModel1.type = 'add';
      this.dialogModel1.title = this.$t('accountManage.xzfptt');
      this.dialogVisible1 = true;
    },
    onEditBody: function (row) {
      this.dialogModel1.type = 'edit';
      this.dialogModel1.title = this.$t('accountManage.bjfptt');
      this.dialogModel1.data = row;
      this.dialogVisible1 = true;
    },
    onDeleteBody: function (id) {
      const tips = this.$t('accountManage.nqdyscxzdfpttm');
      this.$showConfirm(this, tips)
        .then(() => {
          this.$postJSON(`${apis.crmPartnerInvoiceDelete}/${id}`).then(() => {
            this.getInvoiceList();
          });
        })
        .catch(() => {});
    },
    onDefault: function (id) {
      this.$postJSON(`${apis.crmPartnerInvoiceUpdateIsDefault}/${id}`).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.getInvoiceList();
      });
    },
    getInvoiceList() {
      this.$getJSON(`${apis.crmPartnerInvoiceList}/${this.userInfo.rootOrgId}`).then((res) => {
        this.invoiceList = res.data;
      });
    },
    // --------------银行卡
    getBankcardList: function () {
      this.$getJSON(apis.partnerBankcardList).then((res) => {
        this.bankcardList = res.data || [];
      });
    },
    // 新增银行卡
    onAddBtn: function () {
      this.dialogModel2.title = this.$t('accountManage.xin_zeng_yin_hang_ka');
      this.dialogModel2.type = 'add';
      this.dialogVisible2 = true;
    },
    // 编辑银行卡
    onEditBtn: function (item) {
      this.dialogModel2.title = this.$t('accountManage.bian_ji_yin_hang_ka');
      this.dialogModel2.type = 'edit';
      this.dialogModel2.data = { item };
      this.dialogVisible2 = true;
    },
    // 删除
    onDeleteBtn: function (bankcardId) {
      this.$showConfirm(this, this.$t('accountManage.nqdyscxzdyhkm'))
        .then(() => {
          this.$deleteJSON(`${apis.partnerBankcardDelete}/${bankcardId}`).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getBankcardList();
          });
        })
        .catch(() => {});
    },
    // 设为默认
    onDefaultBtn: function (bankcardId) {
      this.$postJSON(`${apis.partnerBankcardDefualt}/${bankcardId}`).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.getBankcardList();
      });
    },
    // 获取登录配置
    getMsgList: function () {
      this.$getJSON(apis.MsgSetList).then((res) => {
        this.site = res.data.site;
        this.email = res.data.email;
        this.sms = res.data.sms;
      });
    },
    // 设置消息
    switchMsg: function (pushChannel, msgClass, msgReceive) {
      this.$postJSON(
        apis.MsgSetup,
        {
          msgClass: msgClass,
          pushChannel: pushChannel,
          msgReceive: msgReceive,
        },
        true
      ).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.getMsgList();
      });
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.accountManage-bd {
  padding: 24px;
  .header-bd .hd-left h1,
  .header-bd .hd-left span {
    color: #ffffff !important;
  }
  .header-bd .hd-right div,
  .header-bd .hd-right h1,
  .header-bd .hd-right h2,
  .header-bd .hd-right span,
  .header-bd .hd-right i.icon {
    color: #ffffff !important;
  }
  .comp-bg {
    height: 250px;
    background: #00a0d9;
    border-radius: 16px;
    position: relative;
    ::after {
      content: '';
      z-index: -1;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      opacity: 0.08;
      background: url('../../images/bg.svg') repeat-x;
      background-size: auto 250px;
    }
  }
  .comp-head {
    position: absolute;
    z-index: 8;
    bottom: -37px;
    left: 24px;
    right: 24px;
    height: 120px;
    border-radius: 16px;
    padding: 0 20px;
    background: url('../../images/bar.png') repeat-x;
    background-size: auto 100%;
    box-shadow: 0px 2px 5.5px rgba(0, 0, 0, 0.02);
    .info {
      padding-left: 22px;
      h1 {
        line-height: 25px;
        color: #202945;
        font-weight: bold;
        font-size: 18px;
      }
      p {
        line-height: 20px;
        color: #1a1a1a;
        font-weight: bold;
        font-size: 14px;
      }
    }
    .btn {
      height: 44px;
      border-radius: 44px;
      // width: 134px;
      padding: 0 24px;
      text-align: center;
      line-height: 44px;
      background: #ffffff;
      font-weight: bold;
      color: #202945;
      cursor: pointer;
      img {
        width: 13px;
        margin-right: 10px;
      }
    }
  }
  .comp-wrapper {
    margin-top: 60px;
    padding-left: 24px;
    .comp-left {
      .title {
        h1 {
          color: #1a1a1a;
          font-size: 18px;
          line-height: 40px;
          font-weight: bold;
        }
        .btn {
          width: 32px;
          height: 32px;
          cursor: pointer;
          line-height: 32px;
          text-align: center;
          border-radius: 32px;
          cursor: pointer;
          background-color: $--color-warning;
          i.icon {
            font-size: 16px;
            color: $--color-text-primary;
          }
        }
      }
      .box {
        ul li {
          color: $--color-text-regular;
          font-weight: bold;
          font-size: 12px;
          height: 18px;
          line-height: 18px;
          margin-bottom: 8px;
          &:last-child {
            margin-bottom: 0;
          }
          span {
            margin-right: 16px;
            color: $--color-text-secondary;
          }
        }
        &.grey {
          background: #f8f8f8;
          border-radius: 16px;
          padding: 24px;
          margin-top: 24px;
        }
      }
      .base {
        padding: 24px 24px 32px;
        border-radius: 16px;
        background-color: #ffffff;
        .sub-title {
          line-height: 18px;
          padding: 24px 0;
          color: #818181;
          font-size: 12px;
          border-bottom: 1px solid rgba(0, 160, 217, 0.16);
          margin-bottom: 24px;
        }
      }
      .address {
        padding: 24px;
        margin-top: 24px;
        border-radius: 16px;
        background-color: #ffffff;
        h2 {
          line-height: 18px;
          height: 18px;
          font-size: 12px;
          font-weight: bold;
          color: $--color-primary;
          margin-top: 4px;
        }
      }
      .invoice {
        padding: 24px;
        margin-top: 24px;
        border-radius: 16px;
        background-color: #ffffff;
        h2 {
          line-height: 18px;
          height: 18px;
          font-size: 12px;
          font-weight: bold;
          color: $--color-primary;
          margin-top: 4px;
        }
      }
    }
    .comp-right {
      margin-left: 24px;
      width: 558px;
      padding-right: 24px;
      .title {
        h1 {
          color: #1a1a1a;
          font-size: 18px;
          line-height: 40px;
          font-weight: bold;
        }
        .btn {
          width: 32px;
          height: 32px;
          cursor: pointer;
          line-height: 32px;
          text-align: center;
          border-radius: 32px;
          cursor: pointer;
          background-color: $--color-warning;
          i.icon {
            font-size: 16px;
            color: $--color-text-primary;
          }
        }
      }
      .msg-set {
        padding: 24px;
        border-radius: 16px;
        background-color: #ffffff;
        h2 {
          line-height: 18px;
          height: 18px;
          font-size: 12px;
          font-weight: bold;
          color: $--color-primary;
          margin-bottom: 16px;
          margin-top: 24px;
        }
        ul li {
          margin: 0 2px;
          .el-switch__label.is-active {
            color: #bfbfbf;
          }
        }
      }
      .bank-set {
        padding: 24px;
        margin-top: 24px;
        border-radius: 16px;
        background-color: #ffffff;
        .el-switch__label {
          color: #ffffff;
        }
        .box {
          margin-top: 24px;
          background: #202945;
          border-radius: 15px;
          padding: 24px;
          color: #ffffff;
          .num {
            font-size: 24px;
            height: 34px;
            line-height: 34px;
            margin: 37px 0;
          }
          .label {
            font-size: 12px;
            width: 130px;
            line-height: 22px;
            font-weight: bold;
          }
          .info {
            font-size: 12px;
            line-height: 22px;
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>
